import React from 'react'
import PageHeader from '../../components/common/PageHeader'
import img1 from "../../assets/images/SERVO_DRIVE.png"
import img2 from "../../assets/images/DRIVES.png"
import img3 from "../../assets/images/HMI.jpg"
import img4 from "../../assets/images/PLC.png"
import img5 from "../../assets/images/UPS.png"
import img6 from "../../assets/images/SERVO_MOTORS.png"

const datas = [
  { title: "Servo drives", detail: "Successfully repairing Allen Brandley, Siemens, Schneider Electric , Mitsubishi , Hitachi Etc.", img: img1 },
  { title: "Drives", detail: "Successfully repairing Omron, ABB, Siemens, Hitachi, Emerson Etc. Brands Drives.", img: img2 },
  { title: "HMI", detail: "Successfully repairing Honeywell, Siemens, Rockwell, ABB Etc.Brands HMI.", img: img3 },
  { title: "PLC", detail: "Successfully repairing Siemens, Allen Bradley, ABB, Omron, Delta, Schneider Etc.Brands PLC.", img: img4 },
  { title: "UPS", detail: "Successfully Repairing Delta Power, Microtek, Eaton, APC, Hitachi Etc.Brands UPS.", img: img5 },
  { title: "Servo Motors", detail: "Successfully repairing Mitsubishi, Yaskawa, Panasonic, Siemens Delta Etc.Brands Servo Motors", img: img6 },
]

const Industry = () => {
  return (
    <section className='welcome-section'>
      <PageHeader title={"Products"} subNav={"Industrial"} />
      <div className='bg-gray-100'>
        <div className="container">
          <div className="sm:py-10 py-6">
            <h2 className='lg:text-4xl sm:text-3xl xsm:text-2xl text-xl font-500 text-center whitespace-nowrap text-gray-700 sm:mb-10 mb-6' >Industrial</h2>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-4 justify-center">
              {
                datas.map((data) =>
                  <div className='max-md:text-center max-xsm:text-start bg-gray-50 shadow-sm cursor-pointer p-4 rounded-md' data-aos="zoom-out" data-aos-duration="1500">
                    <div className='h-full pt-4 overflow-hidden'>
                      <h2 className='sm:text-2xl text-xl text-center text-gray-600 font-500 mb-2'>{data.title}</h2>
                      <h2 className='text-center sm:text-base text-sm text-gray-600 font-600 mb-6'>{data.detail}</h2>
                      <div className='bg-gray-100 p-4 md:aspect-square'>
                        <img className='w-full h-full max-h-[400px] object-contain' src={data.img} alt="" />
                      </div>
                    </div>
                  </div>)
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Industry
